// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IDataContext } from '../interfaces/IDataContext'
import {  Demand, DemandLevel, DemandSearchResultDTO } from '../api/schemas/schema'
import { DropdownOption } from './enumHelper'
import { t } from '../i18n/i18n'
import { api } from './apiHelper'

export const searchDemands = async (
   searchValue: string,
   setSearchResult: React.Dispatch<React.SetStateAction<DemandSearchResultDTO[]>>,
   targetDemandLevel: number,
   accessToken: string,
   filterOutDemand?: Demand
) => {
   let result = (await api(accessToken).demandSearchList({ searchText: searchValue, demandLevel: targetDemandLevel })).data
   if (result.length > 0) {
      result = result.sort((a: any, b: any) => a.publicId - b.publicId)
      if (filterOutDemand) {
         result = result.filter((x) => x.id !== filterOutDemand.id)
      }
      setSearchResult(result)
   } else {
      setSearchResult([])
   }
}

export const getTargetDemandLevel = (dataContext: IDataContext): DemandLevel.One | DemandLevel.Two => {
   const { selectedDemands } = dataContext.state
   const targetIsLvlOne = selectedDemands.some((demand) => demand.level === DemandLevel.Two)
   return targetIsLvlOne ? DemandLevel.One : DemandLevel.Two
}

export const getDemandLeveLOptions = (selectedDemandLevel: DemandLevel): DropdownOption[] => {
   const options = [
      { key: DemandLevel.Two, text: 'D2' },
      { key: DemandLevel.Three, text: 'D3' },
   ]
   if (selectedDemandLevel === DemandLevel.One) {
      options.splice(0, 0, { key: DemandLevel.One, text: 'D1' })
   }
   return options
}

export const getDemandSearchBoxLabel = (targetDemandLevel: DemandLevel) => {
   return targetDemandLevel === DemandLevel.One ? t('SearchForLevelOneDemands') : t('SearchForLevelTwoDemands')
}
